import { Tag } from "antd";
import { STATUS_COLORS } from "../helpers/constants";

export function DocumentStatusTag({ status }: { status: string }) {
  return <Tag color={STATUS_COLORS[status] ?? "default"}>{status.replaceAll("_", " ")}</Tag>;
}

// The same text, for CSV exports (helpers/csv.ts).
DocumentStatusTag.csvText = ({ status }: { status: string }) => status.replaceAll("_", " ");
